import React from 'react'
import PropTypes from 'prop-types'
import styles from './style.module.scss'
import ArticleGrid from '../article/articleGrid'
import ConditionalSliderVideosHeader from '../header/conditionalSliderVideosHeader'

const getVideosLink = selectedData => {
  const routeTo = selectedData?.seo?.sSlug || ''
  return `/${routeTo.includes('cricket/series') ? `${routeTo}/videos` : `${routeTo}?tab=videos`}`
}

const ScrollableVideoList = ({ selectedData }) => {
  if (!selectedData?.arrayData?.length) return null
  return (
    <div>
      <div className={`${styles.bodyContainer} position-relative`}>
        <div className="scrollable-wrapper scroll-list">
          <div className="d-inline-flex">
            {selectedData?.arrayData.slice(0, 5).map((item, index) => {
              const thumbnailUrl = item?.aThumbnails?.at(-1)?.sUrl
              return (
                <div key={`video-item-${index}`} className={styles.videoCard}>
                  <ArticleGrid
                    isVideo={true}
                    data={item}
                    videoThumbnail={thumbnailUrl}
                    hideDate
                  />
                </div>
              )
            })}
          </div>
        </div>
      </div>
    </div>
  )
}

ScrollableVideoList.propTypes = {
  selectedData: PropTypes.object
}

function HomePopularVideos({ data = [] }) {
  const sortedData = (data?.length > 1 ? [data?.[1], data?.[0], data?.[2]] : [])?.map(item => ({
    title: item?.sName,
    arrayData: item?.aVideos || [],
    seo: item?.oSeo || {}
  }))

  return (
    <section className={styles.homePopularVideosContainer}>
      <ConditionalSliderVideosHeader headerTitle='Popular Videos' data={sortedData} getMoreLink={getVideosLink}>
        <ScrollableVideoList />
      </ConditionalSliderVideosHeader>
    </section>
  )
}

HomePopularVideos.propTypes = {
  data: PropTypes.array
}

export default HomePopularVideos
